module.exports = __webpack_public_path__ + "static/img/8bg_6.f9e0474.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_6.png
// module id = 766
// module chunks = 1